export const epochToFormattedDate = (epoch: any): any =>{
  if(epoch){
    const formattedDate = new Date(epoch).toLocaleString();
    return formattedDate.replace(',', '  |');
  }
}


export const getUserId =()=>{
  let partnerUser = localStorage.getItem('partnerId') 

  let user = localStorage.getItem('sess_user')

  if(partnerUser){
   return partnerUser
  }else{
    if(user){
      let userID = JSON.parse(user)?.user?.userId
      return userID

    }
  }
}

export function formatDateTime(dateString: string): string {
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  const formatter = new Intl.DateTimeFormat("en-GB", options);
  const parts = formatter.formatToParts(date);

  const day = parts.find((part) => part.type === "day")?.value ?? "00";
  const month = parts.find((part) => part.type === "month")?.value ?? "00";
  const year = parts.find((part) => part.type === "year")?.value ?? "0000";
  const hour = parts.find((part) => part.type === "hour")?.value ?? "00";
  const minute = parts.find((part) => part.type === "minute")?.value ?? "00";
  const period = (
    parts.find((part) => part.type === "dayPeriod")?.value ?? "AM"
  ).toUpperCase();

  return `${day}-${month}-${year} | ${hour}:${minute} ${period}`;
}
